// extracted by mini-css-extract-plugin
module.exports = {"static":"v_J","map":"v_K"};